export default {
  markDay: 'Good afternoon, today marks your 100th day at Tencent',
  personalInfo: {
    title: 'Personal Info',
    position: 'Employee of the Hong Kong and Macau Business Expansion team',

    desc: {
      phone: 'Phone',
      mobile: 'Mobile',
      seat: 'Seat',
      email: 'Email',
      position: 'Position',
      leader: 'Leader',
      entity: 'Entity',
      joinDay: 'Day of join',
      group: 'Group',
    },
  },
  contentList: 'Content List',
  visitData: 'Visit Data',
  teamMember: 'Team Member',
  serviceProduction: 'Service Product',
};
